import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { PlantingLifecycleStatus } from '../../../models/Planting';
import { PLANTING_STATUS_META } from '../constants';

interface PlantingLifecycleTagProps {
  status?: PlantingLifecycleStatus | null;
  className?: string;
}

const PlantingLifecycleTag: React.FC<PlantingLifecycleTagProps> = ({ status, className }) => {
  const { t } = useTranslation('plantings');
  if (!status) {
    return <Tag className={className}>{t('status.notSet')}</Tag>;
  }

  const meta = PLANTING_STATUS_META[status];

  return (
    <Tag className={className} color={meta?.color}>
      {meta?.label ?? status}
    </Tag>
  );
};

export default PlantingLifecycleTag;
